import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Card,
  CardContent,
  Typography,
  Button,
  Container,
  Avatar,
} from '@mui/material';
import {
  Person as PersonIcon,
  Pets as PetsIcon,
  ArrowForward as ArrowForwardIcon,
} from '@mui/icons-material';

const AccountType: React.FC = () => {
  const navigate = useNavigate();

  const handleClientSelection = () => {
    navigate('/register/client');
  };

  const handleVeterinarianSelection = () => {
    navigate('/register/clinic');
  };

  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box textAlign="center" mb={4}>
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Alege tipul de cont
        </Typography>
        <Typography variant="h6" color="text.secondary">
          Selecteaza tipul de cont care se potriveste cel mai bine cu nevoile tale
        </Typography>
      </Box>

      <Box 
        display="flex" 
        flexDirection={{ xs: 'column', md: 'row' }}
        gap={4} 
        justifyContent="center"
        alignItems="stretch"
      >
        {/* Client Card */}
        <Box flex={{ xs: 1, md: 0.5 }}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: 8,
              },
            }}
            onClick={handleClientSelection}
          >
            <CardContent sx={{ textAlign: 'center', flexGrow: 1, p: 4 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  mx: 'auto',
                  mb: 2,
                  bgcolor: 'primary.main',
                }}
              >
                <PersonIcon sx={{ fontSize: 40 }} />
              </Avatar>
              
              <Typography variant="h4" component="h2" gutterBottom color="primary">
                Client (Stapan)
              </Typography>
              
              <Typography variant="body1" color="text.secondary" paragraph>
                Pentru persoanele care au animale de companie si doresc sa:
              </Typography>
              
              <Box component="ul" sx={{ textAlign: 'left', pl: 2 }}>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Programeze consultatii pentru animalele lor
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Gestioneze fisele medicale ale animalelor
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Faca plati online pentru serviciile veterinare
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Primeasca notificari despre programari si vaccinari
                </Typography>
              </Box>

              <Button
                variant="contained"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{ mt: 3 }}
                fullWidth
              >
                Creeaza cont Client
              </Button>
            </CardContent>
          </Card>
        </Box>

        {/* Veterinarian Card */}
        <Box flex={{ xs: 1, md: 0.5 }}>
          <Card
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              cursor: 'pointer',
              transition: 'all 0.3s ease',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: 8,
              },
            }}
            onClick={handleVeterinarianSelection}
          >
            <CardContent sx={{ textAlign: 'center', flexGrow: 1, p: 4 }}>
              <Avatar
                sx={{
                  width: 80,
                  height: 80,
                  mx: 'auto',
                  mb: 2,
                  bgcolor: 'secondary.main',
                }}
              >
                <PetsIcon sx={{ fontSize: 40 }} />
              </Avatar>
              
              <Typography variant="h4" component="h2" gutterBottom color="secondary">
                Veterinar
              </Typography>
              
              <Typography variant="body1" color="text.secondary" paragraph>
                Pentru medicii veterinari care doresc sa:
              </Typography>
              
              <Box component="ul" sx={{ textAlign: 'left', pl: 2 }}>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Gestioneze programarile si consultatiile
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Acceseze fisele medicale ale animalelor
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Administreze clinicile veterinare
                </Typography>
                <Typography component="li" variant="body2" color="text.secondary" sx={{ mb: 1 }}>
                  Colaboreze cu alti veterinari din retea
                </Typography>
              </Box>

              <Button
                variant="contained"
                color="secondary"
                size="large"
                endIcon={<ArrowForwardIcon />}
                sx={{ mt: 3 }}
                fullWidth
              >
                Creeaza cont Veterinar
              </Button>
            </CardContent>
          </Card>
        </Box>
      </Box>

      <Box textAlign="center" mt={4}>
        <Typography variant="body2" color="text.secondary">
          Ai deja un cont?{' '}
          <Button
            variant="text"
            color="primary"
            onClick={() => navigate('/login')}
            sx={{ textTransform: 'none' }}
          >
            Conecteaza-te aici
          </Button>
        </Typography>
      </Box>
    </Container>
  );
};

export default AccountType; 
